import {Component, Input, OnInit} from '@angular/core';
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { Observable } from "rxjs";
import {TranslationFeatureModule} from "../../i18n/TranslationFeatureModule";

@Component({
  selector: 'common-toolbar',
  standalone: true,
    imports: [CommonModule, MatToolbarModule, MatButtonModule, MatIconModule, NgOptimizedImage, MatCardModule, TranslationFeatureModule],
  templateUrl: 'toolbar.component.html',
  styles: [`
    img {
      max-width: 100%;
      max-height: 100%;
    }
    
  `]
})

export class ToolbarComponent implements OnInit {
  @Input() logo!: Observable<any>;
  @Input() maxContentWidth?: string;
  imageClass = 'w-24';

  pathToPROPUP = 'https://www.propup.at/impressum';
  pathToLogo = 'assets/images/propup_schwarz_transparent.png';
  pathToCustomer = 'https://www.propup.at';

  ngOnInit() {
    this.logo.subscribe((img: any) => {
      this.imageClass = this.getImageClass(img);
      this.pathToCustomer = this.getImageUrl(img);
    });
  }

  getImageClass(img: any) {
    switch (img) {
      case '/assets/themes/sulek/sulek.png':
        return 'h-14'
      case 'assets/themes/grasl/grasl-logo.png':
        return 'h-14'
      case 'assets/themes/altera/altera.png':
        return 'h-8'
      case 'assets/themes/hagsteiner/hagsteiner.png':
        return 'h-10'
      case 'assets/themes/edelweiss/edelweiss.png':
        return 'h-14'
      case 'assets/themes/eraImmo/eraImmo.png':
        return 'h-14'
      case 'assets/themes/sonnberger/sonnberger.png':
        return 'h-14'
      case 'assets/themes/virimo/virimo.png':
        return 'h-14'
      case 'assets/themes/jalea/jalea.png':
        return 'h-14'
      case 'assets/themes/realwert/realwert.png':
        return 'h-10'
      case 'assets/themes/strigl/strigl.png':
        return 'h-10'
      case 'assets/themes/immobilienring/immobilienring.png':
        return 'h-10'
      case '/assets/themes/froeschl/froeschl.png':
        return 'w-32'
      case 'assets/themes/norisk/norisk.png':
        return 'h-14'
      case 'assets/themes/mayrImmo/mayrimmo.png':
        return 'h-16'
      case 'assets/themes/prosch/prosch.png':
        return 'h-14'
      case 'assets/themes/ahImmobilien/ahImmobilien.png':
        return 'h-14'
      case 'assets/themes/aaaaImmobilien/aaaaImmobilien.png':
        return 'h-14'
      case 'assets/themes/qualis/qualis.png':
        return 'h-10'
      default:
        return 'w-24'
    }
  }

  getImageUrl(url: any) {
    switch (url) {
      case '/assets/themes/sulek/sulek.png':
        return 'https://www.sulek.immobilien/'
      case 'assets/themes/grasl/grasl-logo.png':
        return 'https://www.grasl-immobilien.at/de'
      case 'assets/themes/altera/altera.png':
        return 'https://www.altera-realestate.at/'
      case 'assets/themes/hagsteiner/hagsteiner.png':
        return 'https://www.hagsteiner.at/de/index.php'
      case 'assets/themes/edelweiss/edelweiss.png':
        return 'https://www.edelweiss-immo.at/'
      case 'assets/themes/eraImmo/eraImmo.png':
        return 'https://era.at/de/'
      case 'assets/themes/sonnberger/sonnberger.png':
        return 'https://sonnberger.co.at/wp/'
      case 'assets/themes/virimo/virimo.png':
        return 'https://virimoestate.at/'
      case 'assets/themes/jalea/jalea.png':
        return 'https://jalea-immobilien.de/'
      case 'assets/themes/realwert/realwert.png':
        return 'https://www.realwert-immobilien.at/'
      case 'assets/themes/strigl/strigl.png':
        return 'https://www.strigl-immobilien.com/'
      case 'assets/themes/immobilienring/immobilienring.png':
        return 'https://www.ir.at/'
      case '/assets/themes/froeschl/froeschl.png':
        return 'https://www.froeschl.estate/'
      case 'assets/themes/norisk/norisk.png':
        return 'https://www.no-risk.at/'
      case 'assets/themes/mayrImmo/mayrimmo.png':
        return 'https://www.mayrimmo.com/'
      case 'assets/themes/prosch/prosch.png':
        return 'https://www.prosch-immo.at/'
      case 'assets/themes/ahImmobilien/ahImmobilien.png':
        return 'https://www.ah.at/'
      case 'assets/themes/aaaaImmobilien/aaaaImmobilien.png':
        return 'https://www.immoi.at/'
      case 'assets/themes/qualis/qualis.png':
        return 'https://www.qualis.cc/'
      case 'assets/themes/remax/logo.png':
        return 'https://www.remax.at/'
      case 'assets/themes/remax-classic/logo.png':
        return 'https://www.remax.de/'
      case 'assets/themes/remax-collection/remaxCollection.png':
        return 'https://www.remax.de/'
      case 'assets/themes/wohncloud/wohncloud.png':
        return 'https://www.wohncloud-immobilien.at/'
      case 'assets/themes/immobilien-melk/immobilien-melk.png':
        return 'https://immobilien-melk.at/'
      default:
        return 'https://www.propup.at'
    }
  }
}
